import { IconApp } from "@/modules/IconApp";

export const Header = () => {
  return (
    <div>
      <IconApp name="logoNovaventa" height={36} width={156} />
    </div>
  );
};
